import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  getFamily: () => client.get("/family").then((r) => r.data),
  login: (name, email, phone) =>
    client.post("/auth/login", { name, email, phone: phone || null }).then((r) => r.data),
  getBookings: () => client.get("/bookings").then((r) => r.data),
  createBooking: (payload) =>
    client.post("/bookings", payload).then((r) => r.data),
  cancelBooking: (id, requester) =>
    client
      .delete(`/bookings/${id}`, { params: { requester } })
      .then((r) => r.data),
  confirmBooking: (id, requester) =>
    client
      .patch(`/bookings/${id}/confirm`, null, { params: { requester } })
      .then((r) => r.data),
  nudgeBooking: (id, requester) =>
    client
      .post(`/bookings/${id}/nudge`, null, { params: { requester } })
      .then((r) => r.data),
  getActivity: () => client.get("/activity").then((r) => r.data),
  getNotes: () => client.get("/notes").then((r) => r.data),
  updateNotes: (payload) => client.put("/notes", payload).then((r) => r.data),
  getWhatsAppSetup: () => client.get("/whatsapp/setup").then((r) => r.data),
  updateContact: (name, payload) =>
    client.put(`/family/${name}/contact`, payload).then((r) => r.data),
  sendWhatsAppInvite: (requester, name) =>
    client
      .post("/whatsapp/invite", null, { params: { requester, ...(name ? { name } : {}) } })
      .then((r) => r.data),
};
